import React from 'react';
import DynamicChart from './DynamicChart';
import DashboardComponentCreator from './DashboardComponentCreator';

// 스타일 객체를 컴포넌트 외부에 상수로 정의
const chartStyle = {
  padding: '10px'
};

/**
 * 스트리밍 중인 응답을 표시하는 컴포넌트 (텍스트와 시각화 인터리빙 지원)
 * React.memo로 래핑하여 불필요한 렌더링 방지 (기본 얕은 비교 사용)
 */
const StreamingResponse = React.memo(({ streamingDisplayBlocks, formatMarkdownLike, isDeveloperMode }) => {
  return (
    <div className="message-container text-left">
      <div className="message-assistant">
        <div className="message-header">
          <span className="message-sender">AI 어시스턴트</span>
        </div>
        <div className="message-content">
          {/* 스트리밍 블록 배열을 순회하며 렌더링 */}
          {streamingDisplayBlocks && streamingDisplayBlocks.length > 0 ? (
            streamingDisplayBlocks.map((block, index) => {
              // Apply custom spacer class conditionally
              const spacerClass = index > 0 ? 'chat-block-spacer' : '';
              
              if (block.type === 'text') {
                // 텍스트 블록 렌더링
                return (
                  <div 
                    key={`block-${index}`}
                    // Apply custom spacer class
                    className={`markdown-content prose compact-prose streaming-text-block ${spacerClass}`}
                    dangerouslySetInnerHTML={{ 
                      __html: formatMarkdownLike(block.content || "", isDeveloperMode)
                    }}
                  />
                );
              } else if (block.type === 'visualization') {
                // 시각화 블록 렌더링
                return (
                  // Apply custom spacer class, remove my-4
                  <div key={block.id || `block-${index}`} className={`visualization-container streaming-visualization-block ${spacerClass}`}>
                    <DynamicChart
                      chartData={block.data}
                      style={block.data?.viz_type === 'webframe' ? {} : chartStyle}
                      debugMode={isDeveloperMode}
                    />
                    {/* 개발자 모드일 때 원본 시각화 데이터도 표시 */}
                    {isDeveloperMode && (
                      <div className="developer-metadata-block" style={{
                        marginTop: '15px',
                        padding: '12px',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #e9ecef',
                        borderRadius: '6px',
                        fontSize: '12px',
                        fontFamily: 'Monaco, Consolas, "Courier New", monospace'
                      }}>
                        <div style={{
                          fontWeight: 'bold',
                          marginBottom: '8px',
                          color: '#495057',
                          fontSize: '13px'
                        }}>
                          🔧 시각화 데이터 (개발자 모드)
                        </div>
                        <pre style={{
                          margin: 0,
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-all',
                          color: '#212529',
                          backgroundColor: '#ffffff',
                          padding: '8px',
                          borderRadius: '4px',
                          border: '1px solid #dee2e6',
                          maxHeight: '300px',
                          overflow: 'auto'
                        }}>
                          {JSON.stringify(block.data, null, 2)}
                        </pre>
                      </div>
                    )}
                  </div>
                );
              } else if (block.type === 'dashboard_component') {
                // 대시보드 컴포넌트 생성 블록 렌더링
                return (
                  <div key={block.id || `block-${index}`} className={`dashboard-component-creation-container streaming-dashboard-component-block ${spacerClass}`}>
                    <DashboardComponentCreator 
                      componentTemplate={block.data.component_template}
                      autoAdd={block.data.auto_add}
                      autoEdit={block.data.auto_edit}
                      onComponentAdded={(template) => {
                        console.log('[StreamingResponse] 컴포넌트 추가 완료:', template);
                      }}
                    />
                  </div>
                );
              } else if (block.type === 'warning') {
                return (
                  <div 
                    key={`block-${index}`}
                    // 경고 스타일 추가
                    className={`warning-block prose compact-prose streaming-warning-block ${spacerClass}`}
                  >
                    <span className="warning-icon">⚠️</span> {/* 경고 아이콘 */}
                    <span 
                      dangerouslySetInnerHTML={{ 
                        __html: formatMarkdownLike(block.content || "", isDeveloperMode)
                      }}
                    />
                  </div>
                );
              }
            })
          ) : (
            // 블록이 없으면 로딩 메시지 표시 (선택 사항)
            <div 
              className="markdown-content prose compact-prose"
              dangerouslySetInnerHTML={{ 
                __html: formatMarkdownLike("응답 생성 중...", isDeveloperMode) 
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}); // 커스텀 비교 함수 제거됨

export default StreamingResponse; 